// extracted by mini-css-extract-plugin
export default {"page":"ph-z","cartModal":"qh-z","checkout":"rh-z","placeholder":"sh-z","account":"th-z"};